import { SubmitTone } from '@/constants/enum';
import { Modal } from '@shopify/polaris';
import { ModalSize } from '@shopify/polaris/build/ts/src/components/Modal';

const PolarisModal = ({
  open,
  onCancel,
  onSubmit,
  children,
  title,
  cancelText,
  submitText,
  submitTone = SubmitTone.DEFAULT,
  loading,
  disabledPrimary,
  disabledCancel,
  size,
}: {
  open: boolean;
  onCancel: () => void;
  onSubmit: () => void;
  children: React.ReactNode;
  title: string;
  cancelText?: string;
  submitText?: string;
  submitTone?: SubmitTone;
  loading?: boolean;
  disabledPrimary?: boolean;
  disabledCancel?: boolean;
  size?: ModalSize;
}) => {
  const primaryAction = submitText
    ? [
        {
          content: submitText,
          onAction: onSubmit,
          destructive: submitTone === SubmitTone.CRITICAL,
          loading,
          disabled: disabledPrimary,
        },
      ]
    : undefined;
  const secondaryActions = cancelText ? [{ content: cancelText, onAction: onCancel, disabled: disabledCancel }] : undefined;
  return (
    <Modal
      open={open}
      onClose={onCancel}
      title={title}
      primaryAction={primaryAction ? primaryAction[0] : undefined}
      secondaryActions={secondaryActions}
      size={size}
    >
      <Modal.Section>{children}</Modal.Section>
    </Modal>
  );
};

const AppModal = ({
  open,
  onCancel,
  onSubmit,
  children,
  title,
  cancelText,
  submitText,
  submitTone = SubmitTone.DEFAULT,
  loading,
  disabledPrimary,
  disabledCancel,
  size,
}: {
  open: boolean;
  onCancel: () => void;
  onSubmit: () => void;
  children: React.ReactNode;
  title: string;
  cancelText?: string;
  submitText?: string;
  submitTone?: SubmitTone;
  loading?: boolean;
  disabledPrimary?: boolean;
  disabledCancel?: boolean;
  size?: ModalSize;
}) => {
  return (
    <PolarisModal
      open={open}
      onCancel={onCancel}
      onSubmit={onSubmit}
      title={title}
      cancelText={cancelText}
      submitText={submitText}
      submitTone={submitTone}
      loading={loading}
      disabledPrimary={disabledPrimary}
      disabledCancel={disabledCancel}
      size={size}
    >
      {children}
    </PolarisModal>
  );
};

export default AppModal;
